<template>
	<div class="c-render-concept">
		<!-- {{ script }} -->
		<div class="c-render-concept__concept">
			<header>
				<strong> Concept </strong>
			</header>
			<section>
				<label> Concept name </label>
				<article>
					{{ concept.concept_name }}
				</article>
			</section>
			<section>
				<label> Angle </label>
				<article>
					{{ concept.angle }}
				</article>
			</section>
			<section>
				<label> Core desire </label>
				<article>
					<span v-for="(desire, i) in concept.core_desire" :key="i">
						{{ desire }},
					</span>
				</article>
			</section>
			<section>
				<label> Solved problem </label>
				<article>
					{{ concept.solved_problem }}
				</article>
			</section>
			<section>
				<label> Emotions to evoke </label>
				<article>
					<span v-for="(emotion, i) in concept.emotion_to_evoke" :key="i">
						{{ emotion }},
					</span>
				</article>
			</section>
		</div>
		<div class="c-render-concept__grid">
			<div class="c-render-concept__hook" v-for="(hook, i) in hooks" :key="i">
				<header>
					<strong> Hook {{ i + 1 }} </strong>
				</header>
				<section>
					<label> Idea </label>
					<article>
						{{ hook.central_idea }}
					</article>
				</section>
				<section>
					<label> Visual hook </label>
					<article>
						{{ hook.visual_hook }}
					</article>
				</section>
				<section>
					<label> Voice over </label>
					<article>
						{{ hook.voice_over }}
					</article>
				</section>
				<section>
					<label> Text overlay </label>
					<article>
						{{ hook.text_overlay }}
					</article>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},

	props: {
		script: {},
	},

	computed: {
		concept: function () {
			return this.script.concept;
		},
		hooks: function () {
			return this.script.hooks;
		},
	},

	methods: {
		next: function () {
			this.$emit('next');
		},
	},
};
</script>

<style lang="scss">
.c-render-concept {
	margin-bottom: 1rem;
	padding: 0.5rem;

	&__concept {
		padding: 0.5rem;
		border: var(--color-bg-3) solid 1px;
		border-radius: var(--border-radius);
	}

	section {
		margin-bottom: 0.5rem;
		article {
			font-size: var(--font-size-xs);

			font-feature-settings: 'case' 0, 'dlig' 0, 'frac' 0, 'dnom' 0, 'numr' 0,
				'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01', 'ss02' 0, 'ss03' 0, 'ss04',
				'ss05' 0, 'ss06' 0, 'ss07' 0, 'ss08' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0,
				'cv04' 0, 'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0,
				'cv11' 0, 'cv12' 0, 'cv13' 0, 'cpsp' 0, 'c2sc' 0, 'salt' 0, 'aalt' 0,
				'calt', 'ccmp', 'locl', 'kern';
		}

		&:last-of-type {
			margin-bottom: 0;
		}

		label {
			display: inline-flex;
			margin-right: var(--margin);
			padding: var(--margin-sm) var(--margin);
			align-items: center;
			font-size: var(--font-size-xxs);
			font-weight: 500;
			line-height: 1;
			background-color: var(--color-bg-3);
			border-radius: var(--border-radius);
			user-select: none;

			span {
				text-transform: capitalize;
			}

			svg {
				width: 20px;
				height: 20px;
				margin-right: var(--margin-sm);
			}
		}
	}

	&__grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-column-gap: 0.5rem;
	}

	&__hook {
		margin-top: 0.5rem;
		padding: 0.5rem;
		border: var(--color-bg-3) solid 1px;
		border-radius: var(--border-radius);
	}
}
</style>
